export enum LogoType {
  CONSTRUCTLY = 'constructly',
  SAMOLET = 'samolet',
}

export interface ILogo {
  logoUrl: string;
  logoType: LogoType;
}
